import { h, render, Component } from 'preact';
import moment from 'moment';
import './time-period.scss';

export default class TimePeriod extends Component {
    constructor(props) {
        super(props);

        let startValue = moment().startOf('day');
        let endValue = moment().endOf('day');
        this.state = {
            selectedPeriodId: '3',
            startValue,
            endValue
        };
    }

    _updateSelected = (value) => {
        let startValue = moment();
        let endValue = moment();
        switch (value) {
            case '1':
                startValue.subtract(3, 'hour');
                break;
            case '2':
                startValue.subtract(24, 'hour');
                break;
            case '4':
                startValue.subtract(1, 'day').startOf('day');
                endValue.subtract(1, 'day').endOf('day');
                break;
            case '5':
                startValue.startOf('isoWeek');
                endValue.endOf('isoWeek');
                break;
            case '6':
                startValue.subtract(1, 'isoWeek').startOf('isoWeek');
                endValue.subtract(1, 'isoWeek').endOf('isoWeek');
                break;
            case '7':
                this.setState({ selectedPeriodId: value });
                return;
            default:
                startValue.startOf('day');
                endValue.endOf('day');
                break;
        }
        this.setState({
            selectedPeriodId: value,
            startValue,
            endValue
        });
    }

    _onStartDateChange = (event) => {
        let newValue = event.target.value;
        if (!newValue) {
            return;
        }

        let datePart = newValue;
        let timePart = this.state.startValue.format('HH:mm:ss');
        this.setState({ startValue: moment(`${datePart} ${timePart}`, 'YYYY-MM-DD HH:mm:ss') });
    }

    _onStartTimeChange = (event) => {
        let newValue = event.target.value;
        if (!newValue) {
            return;
        }

        let datePart = this.state.startValue.format('YYYY-MM-DD');
        let timePart = newValue + ':00';
        this.setState({ startValue: moment(`${datePart} ${timePart}`, 'YYYY-MM-DD HH:mm:ss') });
    }

    _onEndDateChange = (event) => {
        let newValue = event.target.value;
        if (!newValue) {
            return;
        }

        let datePart = newValue;
        let timePart = this.state.endValue.format('HH:mm:ss');
        this.setState({ endValue: moment(`${datePart} ${timePart}`, 'YYYY-MM-DD HH:mm:ss') });
    }

    _onEndTimeChange = (event) => {
        let newValue = event.target.value;
        if (!newValue) {
            return;
        }

        let datePart = this.state.endValue.format('YYYY-MM-DD');
        let timePart = newValue + ':59';
        this.setState({ endValue: moment(`${datePart} ${timePart}`, 'YYYY-MM-DD HH:mm:ss') });
    }

    _onAcceptClick = () => {
        this.props.updatePeriod(this.state.startValue, this.state.endValue);
        this.props.close();
    }

    render(props, state) {
        let inputsDisabled = state.selectedPeriodId != '7';

        return (
            <div class="time-period-wrapper">
                <div class="time-period-panel">
                    <div class="time-period-title">
                        <span>{fmtools.translate('TrackPeriod')}</span>
                    </div>
                    <div class="time-period-radio">
                        <span onClick={() => this._updateSelected('1')}>
                            <input
                                id="period1"
                                type="radio"
                                value="1"
                                checked={state.selectedPeriodId == '1'}
                            />
                            <label>{fmtools.translate('last3hour')}</label>
                        </span>
                        <span onClick={() => this._updateSelected('2')}>
                            <input
                                id="period2"
                                type="radio"
                                value="2"
                                checked={state.selectedPeriodId == '2'}
                            />
                            <label>{fmtools.translate('last24hour')}</label>
                        </span>
                        <span onClick={() => this._updateSelected('3')}>
                            <input
                                id="period3"
                                type="radio"
                                value="3"
                                checked={state.selectedPeriodId == '3'}
                            />
                            <label>{fmtools.translate('this_day')}</label>
                        </span>
                        <span onClick={() => this._updateSelected('4')}>
                            <input
                                id="period4"
                                type="radio"
                                value="4"
                                checked={state.selectedPeriodId == '4'}
                            />
                            <label>{fmtools.translate('last_day')}</label>
                        </span>
                        <span onClick={() => this._updateSelected('5')}>
                            <input
                                id="period5"
                                type="radio"
                                value="5"
                                checked={state.selectedPeriodId == '5'}
                            />
                            <label>{fmtools.translate('this_week')}</label>
                        </span>
                        <span onClick={() => this._updateSelected('6')}>
                            <input
                                id="period6"
                                type="radio"
                                value="6"
                                checked={state.selectedPeriodId == '6'}
                            />
                            <label>
                                {fmtools.translate('last_week')}
                            </label>
                        </span>
                        <span onClick={() => this._updateSelected('7')}>
                            <input
                                id="period7"
                                type="radio"
                                value="7"
                                checked={state.selectedPeriodId == '7'}
                            />
                            <label>
                                {fmtools.translate('AtChoice')}
                            </label>
                        </span>
                    </div>
                    <div class="time-period-inputs">
                        <span>{fmtools.translate('BeginBig')}:</span>
                        <input
                            type="date"
                            disabled={inputsDisabled}
                            value={state.startValue.format('YYYY-MM-DD')}
                            onChange={this._onStartDateChange}
                        />
                        <input
                            type="time"
                            disabled={inputsDisabled}
                            value={state.startValue.format('HH:mm')}
                            onChange={this._onStartTimeChange}
                        />
                        <span>{fmtools.translate('EndBig')}:</span>
                        <input
                            type="date"
                            disabled={inputsDisabled}
                            value={state.endValue.format('YYYY-MM-DD')}
                            onChange={this._onEndDateChange}
                        />
                        <input
                            type="time"
                            disabled={inputsDisabled}
                            value={state.endValue.format('HH:mm')}
                            onChange={this._onEndTimeChange}
                        />
                    </div>
                    <div class="time-period-buttons">
                        <button onClick={this._onAcceptClick}>
                            {fmtools.translate('Save')}
                        </button>
                        <button onClick={props.close}>
                            {fmtools.translate('Cancel')}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}
